import ifiHttp from '..';
import endpoints from '@api/repository';

export default {
    async getAllTests(token, roomId) {
        return ifiHttp.sendHttpRequest({
            url: roomId ? endpoints.getAllTests + roomId.toString() + '/' : endpoints.getAllFacultyTests,
            method: ifiHttp.Methods.GET, token: token
        });
    },
    async getTestDetails(token, testId) {
        return ifiHttp.sendHttpRequest({url: endpoints.getTestDetails + testId.toString() + "/", method: ifiHttp.Methods.GET, token: token});
    },
    async uploadQuestionDetails(token, questionDetails){
        return ifiHttp.sendHttpRequest({ url: endpoints.uploadQuestionDetails + questionDetails.tid.toString() + "/", method: ifiHttp.Methods.POST, token: token, body: questionDetails })
    },
    async deleteTest(token, testId){
        return ifiHttp.sendHttpRequest({ url: endpoints.deleteTest, method: ifiHttp.Methods.POST, token: token, body: {'test_id': testId} });
    },
    async getTestQuestions(token, testId) {
        return ifiHttp.sendHttpRequest({ url: endpoints.getTestQuestions + testId.toString() + "/", method: ifiHttp.Methods.GET, token: token });
    },
    async deleteQuestion(token, questionId){
        return ifiHttp.sendHttpRequest({ url: endpoints.deleteQuestion, method: ifiHttp.Methods.POST, token: token, body: {'question_id': questionId} });
    },
    async submitTest(token, testData, testId) {
        return ifiHttp.sendHttpRequest({ url: endpoints.submitTest + testId + '/', method: ifiHttp.Methods.POST, token: token, body: testData });
    },
    async getCheatersFromServer(token, testId) {
        return ifiHttp.sendHttpRequest({ url: endpoints.getCheatersFromServer + testId + '/', method: ifiHttp.Methods.GET, token: token });
    },
    async getAllResultsFromServer(token, testId) {
        return ifiHttp.sendHttpRequest({ url: endpoints.getTestStatsFromServer + testId + '/', method: ifiHttp.Methods.GET, token: token });
    },
    async getStudentResultsFromServer(token, testId, studentId) {
        return ifiHttp.sendHttpRequest({ url: endpoints.getStudentResultsFromServer + testId + '/' + studentId + '/', method: ifiHttp.Methods.GET, token: token });
    },
    async sendCheatingNotification(token, testId) {
        return ifiHttp.sendHttpRequest({ url: endpoints.sendCheatingNotification, method: ifiHttp.Methods.POST, token: token, body: {'test_id': testId} });
    },
    async getTestStudentDetails(token, studentId) {
        return ifiHttp.sendHttpRequest({ url: endpoints.getTestStudentDetails + studentId + '/', method: ifiHttp.Methods.GET, token: token });
    },

}